import { __module as T } from "../../../../_virtual/ModalPortal.js";
import $ from "react";
import V from "prop-types";
import "../helpers/focusManager.js";
import { s as z } from "../helpers/scopeTab.js";
import "../helpers/ariaAppHider.js";
import "../helpers/classList.js";
import "../helpers/safeHTMLElement.js";
import "../helpers/portalOpenInstances.js";
import "../helpers/bodyTrap.js";
import { __exports as G } from "../../../../_virtual/safeHTMLElement.js";
import { __exports as J } from "../../../../_virtual/focusManager.js";
import { __exports as Q } from "../../../../_virtual/ariaAppHider.js";
import { __exports as X } from "../../../../_virtual/classList.js";
import { __exports as Y } from "../../../../_virtual/portalOpenInstances.js";
(function(E, O) {
  Object.defineProperty(O, "__esModule", {
    value: !0
  });
  var c = Object.assign || function(a) {
    for (var n = 1; n < arguments.length; n++) {
      var s = arguments[n];
      for (var e in s)
        Object.prototype.hasOwnProperty.call(s, e) && (a[e] = s[e]);
    }
    return a;
  }, A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
    return typeof a;
  } : function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, R = /* @__PURE__ */ function() {
    function a(n, s) {
      for (var e = 0; e < s.length; e++) {
        var t = s[e];
        t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(n, t.key, t);
      }
    }
    return function(n, s, e) {
      return s && a(n.prototype, s), e && a(n, e), n;
    };
  }(), w = $, g = V, o = m(g), D = J, p = C(D), F = z, H = m(F), k = Q, N = C(k), x = X, d = C(x), v = G, S = m(v), L = Y, M = m(L);
  function C(a) {
    if (a && a.__esModule)
      return a;
    var n = {};
    if (a != null)
      for (var s in a)
        Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    return n.default = a, n;
  }
  function m(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function P(a, n) {
    if (!(a instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function q(a, n) {
    if (!a)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : a;
  }
  function W(a, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    a.prototype = Object.create(n && n.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(a, n) : a.__proto__ = n);
  }
  var b = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, j = function(n) {
    return n.code === "Tab" || n.keyCode === 9;
  }, I = function(n) {
    return n.code === "Escape" || n.keyCode === 27;
  }, h = 0, _ = function(a) {
    W(n, a);
    function n(s) {
      P(this, n);
      var e = q(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, s));
      return e.setOverlayRef = function(t) {
        e.overlay = t, e.props.overlayRef && e.props.overlayRef(t);
      }, e.setContentRef = function(t) {
        e.content = t, e.props.contentRef && e.props.contentRef(t);
      }, e.afterClose = function() {
        var t = e.props, l = t.appElement, i = t.ariaHideApp, r = t.htmlOpenClassName, u = t.bodyOpenClassName, f = t.parentSelector, y = f && f().ownerDocument || document;
        u && d.remove(y.body, u), r && d.remove(y.getElementsByTagName("html")[0], r), i && h > 0 && (h -= 1, h === 0 && N.show(l)), e.props.shouldFocusAfterRender && (e.props.shouldReturnFocusAfterClose ? (p.returnFocus(e.props.preventScroll), p.teardownScopedFocus()) : p.popWithoutFocus()), e.props.onAfterClose && e.props.onAfterClose(), M.default.deregister(e);
      }, e.open = function() {
        e.beforeOpen(), e.state.afterOpen && e.state.beforeClose ? (clearTimeout(e.closeTimer), e.setState({ beforeClose: !1 })) : (e.props.shouldFocusAfterRender && (p.setupScopedFocus(e.node), p.markForFocusLater()), e.setState({ isOpen: !0 }, function() {
          e.openAnimationFrame = requestAnimationFrame(function() {
            e.setState({ afterOpen: !0 }), e.props.isOpen && e.props.onAfterOpen && e.props.onAfterOpen({
              overlayEl: e.overlay,
              contentEl: e.content
            });
          });
        }));
      }, e.close = function() {
        e.props.closeTimeoutMS > 0 ? e.closeWithTimeout() : e.closeWithoutTimeout();
      }, e.focusContent = function() {
        return e.content && !e.contentHasFocus() && e.content.focus({ preventScroll: !0 });
      }, e.closeWithTimeout = function() {
        var t = Date.now() + e.props.closeTimeoutMS;
        e.setState({ beforeClose: !0, closesAt: t }, function() {
          e.closeTimer = setTimeout(e.closeWithoutTimeout, e.state.closesAt - Date.now());
        });
      }, e.closeWithoutTimeout = function() {
        e.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, e.afterClose);
      }, e.handleKeyDown = function(t) {
        j(t) && (0, H.default)(e.content, t), e.props.shouldCloseOnEsc && I(t) && (t.stopPropagation(), e.requestClose(t));
      }, e.handleOverlayOnClick = function(t) {
        e.shouldClose === null && (e.shouldClose = !0), e.shouldClose && e.props.shouldCloseOnOverlayClick && (e.ownerHandlesClose() ? e.requestClose(t) : e.focusContent()), e.shouldClose = null;
      }, e.handleContentOnMouseUp = function() {
        e.shouldClose = !1;
      }, e.handleOverlayOnMouseDown = function(t) {
        !e.props.shouldCloseOnOverlayClick && t.target == e.overlay && t.preventDefault();
      }, e.handleContentOnClick = function() {
        e.shouldClose = !1;
      }, e.handleContentOnMouseDown = function() {
        e.shouldClose = !1;
      }, e.requestClose = function(t) {
        return e.ownerHandlesClose() && e.props.onRequestClose(t);
      }, e.ownerHandlesClose = function() {
        return e.props.onRequestClose;
      }, e.shouldBeClosed = function() {
        return !e.state.isOpen && !e.state.beforeClose;
      }, e.contentHasFocus = function() {
        return document.activeElement === e.content || e.content.contains(document.activeElement);
      }, e.buildClassName = function(t, l) {
        var i = (typeof l > "u" ? "undefined" : A(l)) === "object" ? l : {
          base: b[t],
          afterOpen: b[t] + "--after-open",
          beforeClose: b[t] + "--before-close"
        }, r = i.base;
        return e.state.afterOpen && (r = r + " " + i.afterOpen), e.state.beforeClose && (r = r + " " + i.beforeClose), typeof l == "string" && l ? r + " " + l : r;
      }, e.attributesFromObject = function(t, l) {
        return Object.keys(l).reduce(function(i, r) {
          return i[t + "-" + r] = l[r], i;
        }, {});
      }, e.state = {
        afterOpen: !1,
        beforeClose: !1
      }, e.shouldClose = null, e.moveFromContentToOverlay = null, e;
    }
    return R(n, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(e, t) {
        process.env.NODE_ENV !== "production" && (e.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), e.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !e.isOpen ? this.open() : !this.props.isOpen && e.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !t.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var e = this.props, t = e.appElement, l = e.ariaHideApp, i = e.htmlOpenClassName, r = e.bodyOpenClassName, u = e.parentSelector, f = u && u().ownerDocument || document;
        r && d.add(f.body, r), i && d.add(f.getElementsByTagName("html")[0], i), l && (h += 1, N.hide(t)), M.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var e = this.props, t = e.id, l = e.className, i = e.overlayClassName, r = e.defaultStyles, u = e.children, f = l ? {} : r.content, y = i ? {} : r.overlay;
        if (this.shouldBeClosed())
          return null;
        var K = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", i),
          style: c({}, y, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, U = c({
          id: t,
          ref: this.setContentRef,
          style: c({}, f, this.props.style.content),
          className: this.buildClassName("content", l),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", c({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), B = this.props.contentElement(U, u);
        return this.props.overlayElement(K, B);
      }
    }]), n;
  }(w.Component);
  _.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, _.propTypes = {
    isOpen: o.default.bool.isRequired,
    defaultStyles: o.default.shape({
      content: o.default.object,
      overlay: o.default.object
    }),
    style: o.default.shape({
      content: o.default.object,
      overlay: o.default.object
    }),
    className: o.default.oneOfType([o.default.string, o.default.object]),
    overlayClassName: o.default.oneOfType([o.default.string, o.default.object]),
    parentSelector: o.default.func,
    bodyOpenClassName: o.default.string,
    htmlOpenClassName: o.default.string,
    ariaHideApp: o.default.bool,
    appElement: o.default.oneOfType([o.default.instanceOf(S.default), o.default.instanceOf(v.SafeHTMLCollection), o.default.instanceOf(v.SafeNodeList), o.default.arrayOf(o.default.instanceOf(S.default))]),
    onAfterOpen: o.default.func,
    onAfterClose: o.default.func,
    onRequestClose: o.default.func,
    closeTimeoutMS: o.default.number,
    shouldFocusAfterRender: o.default.bool,
    shouldCloseOnOverlayClick: o.default.bool,
    shouldReturnFocusAfterClose: o.default.bool,
    preventScroll: o.default.bool,
    role: o.default.string,
    contentLabel: o.default.string,
    aria: o.default.object,
    data: o.default.object,
    children: o.default.node,
    shouldCloseOnEsc: o.default.bool,
    overlayRef: o.default.func,
    contentRef: o.default.func,
    id: o.default.string,
    overlayElement: o.default.func,
    contentElement: o.default.func,
    testId: o.default.string
  }, O.default = _, E.exports = O.default;
})(T, T.exports);
var me = T.exports;
export {
  me as M
};
